import React from 'react'
import AddAssetsForm from '../../components/Admin/AddAssetsForm';

const AddAssets = () => {
  return (
    <AddAssetsForm />
  )
}

export default AddAssets;